import React               from 'react';
import { isNullOrUndefined }    from 'rewire-common';
import { Observe }              from 'rewire-core';
import { FormView }             from 'rewire-ui';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import EditDialogModel          from './EditDialogModel';

export interface IDocumentDialogProps<T = EditDialogModel> {
  model: T;
  minWidth?: number | string;
  minHeight?: number | string;
  actions?: string[];
}

export class DocumentDialog extends React.PureComponent<IDocumentDialogProps> {
  model: EditDialogModel;
  constructor(props: IDocumentDialogProps) {
    super(props);
    this.model = props.model;
  }

  componentWillUnmount() {
    this.model.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={this.model.form} onSubmit={this.model.actionFn('save')}>
        <Observe render={() => (
           this.model.form.fields.map((field: any) =>
            field.visible
              ? <div key={field.name} className='content'>
                  <field.Editor className='span1' />
                </div>
              : null
            )
        )} />
      </FormView>
    )} />;
  });

  render() {
    const minWidth  = !isNullOrUndefined(this.props.minWidth) ? this.props.minWidth : '200px';
    const minHeight = !isNullOrUndefined(this.props.minHeight) ? this.props.minHeight : '200px';
    const actions   = this.props.actions ?? ['cancel', 'save'];

    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: this.model, actions: actions}} DraggableResizableBoxProps={{minWidth: minWidth, minHeight: minHeight}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}
